export const styles = {
  // Global styles to override some Chakra defaults
  global: {
    body: {
      minHeight: '100vh',
      fontFamily: `body`,
      transitionProperty: 'background-color',
      transitionDuration: 'normal',
      position: 'static',
    },
    '*::placeholder': {
      color: 'chakra-placeholder-color',
    },
    '*, *::before, &::after': {
      borderColor: 'chakra-border-color',
    },

    '.chakra-text .chakra-link': {
      textDecoration: 'underline',
    },

    '.chakra-card': {
      backgroundColor: 'card-bg-layer-1',
    },

    '.chakra-card .chakra-card': {
      backgroundColor: 'card-bg-layer-2',
    },

    '.chakra-card .chakra-card .chakra-card': {
      backgroundColor: 'card-bg-layer-3',
    },

    '.chakra-card .chakra-card .chakra-card .chakra-card': {
      backgroundColor: 'card-bg-layer-4',
    },

    '.chakra-card .chakra-card .chakra-card .chakra-card .chakra-card': {
      backgroundColor: 'card-bg-layer-5',
    },
  },
}
